import { createSlice } from '@reduxjs/toolkit';
import { RtcEngine } from '../../services/agora/rtcEngine';
import { ResponseLiveInfo } from '../../services/api/models/response/responseLive';

export interface TopPageState {
  rtcEngine?: RtcEngine;
  officialLives?: ResponseLiveInfo[];
}

const initState: TopPageState = {};

const topPageSlice = createSlice({
  name: 'top-page',
  initialState: initState,
  reducers: {
    initCarousel: (state) => {
      state.rtcEngine = new RtcEngine();
    },
    destroyCarousel: (state) => {
      state.rtcEngine?.destroy();
      state.rtcEngine = undefined;
      state.officialLives = undefined;
    },
    updateOfficialLives: (state, action) => {
      state.officialLives = action.payload;
    },
  },
});

export const { initCarousel, destroyCarousel, updateOfficialLives } =
  topPageSlice.actions;
export const TopPageReducer = topPageSlice.reducer;
